import { withPrefix } from 'gatsby';
import React, { Component } from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import getPPPCoupon from '../../utils/getPPPCoupon';
import getPPPData from '../../utils/getPPPData';
import log from '../../utils/log';
import Sold from '../Basic/Sold';
import A from '../Basic/A';
import P from '../TOC/P';
import { fullPrice } from '../../config/SiteConfig';

export default class PPP extends Component {
	constructor(props) {
		super(props);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.getCoupon = this.getCoupon.bind(this);
		this.state = {
			country: '',
			discount: 0,
			discountPercent: 0,
			coupon: '',
			btnTxt: 'GENERATE DISCOUNT COUPON →',
			isLoading: true,
			invert: this.props.invert,
			noLink: this.props.noLink,
		};
	}

	async componentDidMount() {
		// Get PPP data.
		const pppData = await getPPPData();
		this.props.log && log('pppData', pppData);

		this.setState({
			discount: pppData.discount,
			discountPercent: pppData.discountPercent,
			country: pppData.country,
			countryName: pppData.countryName,
			btnTxt: `GENERATE ${pppData.discountPercent}% OFF COUPON →`,
			isLoading: false,
		});
	}

	async getCoupon() {
		this.setState({ btnTxt: `Generating coupon…` });
		const pppCoupon = await getPPPCoupon();
		this.props.log && log('pppCoupon', pppCoupon);
		this.setState({ coupon: pppCoupon });
	}

	render() {
		const { country, countryName, discount, discountPercent, coupon, btnTxt, isLoading, invert } = this.state;

		if (isLoading || discount === 0) {
			return null;
		}

		// console.log('invert', invert);
		return (
			<Wrap color={invert}>
				<Inner>
					<Flag>
						<img
							loading="lazy"
							className="lazyload"
							data-src={withPrefix(`flags/${country.toLowerCase()}.svg`)}
							alt={country}
						/>
					</Flag>
					<Msg>
						<P>
							Hello! You're coming from <strong>{countryName}</strong> where this course might be a bit
							expensive. <br />I believe in Learning > Earning so I offer{' '}
							<strong>Purchasing Power Parity</strong> that makes it affordable everywhere in the world.
							If you need it, then I can offer a total <strong>{discountPercent}% off</strong> the retail
							${fullPrice}&nbsp;price.
						</P>
						<P>
							{this.state.coupon ? (
								<>
									<strong>
										THE RETAIL $149 COURSE PRICE WILL BE {discountPercent}% OFF WITH THIS COUPON{' '}
									</strong>
									:{' '}
									<Table>
										<Code>{coupon}</Code> ← use in the checkout{' '}
										{this.state.noLink ? (
											`↑`
										) : (
											<>
												→ <A href="#signup">BUY NOW!</A>
											</>
										)}
									</Table>
								</>
							) : (
								<>
									<Btn color={invert} onClick={this.getCoupon}>
										{btnTxt}
									</Btn>
									<Join>
										— JOIN <Sold />+ ALREADY LEARNING!
									</Join>
								</>
							)}
						</P>
					</Msg>
				</Inner>
			</Wrap>
		);
	}
}

const Wrap = styled.div`
	display: table;
	width: 100%;
	background: ${(p) => (p.color ? p.theme.gr2 : p.theme.gr5)};
	color: ${(p) => (p.color ? p.theme.w : p.theme.black1)};
	padding: ${(p) => p.theme.vr * 1}rem;
	margin: 0 auto;

	${rmq('430')} {
		padding: ${(p) => p.theme.vr * 0.5}rem;
	}

	${rmq('ms')} {
		padding: ${(p) => p.theme.vr * 0.5}rem ${(p) => p.theme.vr * 0.1}rem;
	}
`;

const Inner = styled.div`
	display: table;
	width: 100%;
	max-width: 75rem;
	margin: 0 auto;
	vertical-align: middle;
`;

const Flag = styled.div`
	display: table-cell;
	width: 10%;
	vertical-align: top;

	${rmq('ml')} {
		vertical-align: middle;
	}

	img {
		max-width: 10rem;
	}
`;

const Msg = styled.div`
	display: table-cell;
	width: 70%;
	vertical-align: middle;
	padding: 0 ${(p) => p.theme.vr * 1}rem;

	p {
		font-family: ${(p) => p.theme.f2};
		font-size: ${(p) => p.theme.vr * 0.8}rem;

		${rmq('ml')} {
			font-size: ${(p) => p.theme.vr * 0.65}rem;
		}

		br {
			${rmq('t')} {
				display: none;
			}
		}
	}

	p:last-child {
		margin-bottom: 0;
	}

	code {
		background: #dedede;
		padding: 0.3rem 0.5rem;
		font-size: 75%;
	}
`;

const Btn = styled.button`
	cursor: pointer;
	border: none;
	text-decoration: none;
	background: ${(p) => (p.color ? p.theme.c : p.theme.c2)};
	color: ${(p) => (p.color ? p.theme.black1 : p.theme.wt)};
	padding: 0.5rem 1rem;
	border-radius: 0 0 0.25rem 0.25rem;
	z-index: 100;
	font-size: 1.3rem;
	transition: all 0.2s ease-in;
	text-transform: uppercase;
	font-family: ${(p) => p.theme.f2};

	&:hover {
		background: ${(p) => (p.color ? p.theme.cinvert : p.theme.c1)};
	}
`;

const Join = styled.span`
	padding: 0 0 0 ${(p) => p.theme.vr * 0.5}rem;

	${rmq('612')} {
		display: none;
	}
`;

const Table = styled.span`
	display: table;
	margin-top: 1rem;
`;

const Code = styled.code`
	color: ${(p) => p.theme.w};
	background: ${(p) => p.theme.main} !important;
	padding: 0.7rem 1rem !important;
	font-weight: bold;
	border-radius: 0.3rem;

	&::selection {
		color: ${(p) => p.theme.main};
		background: ${(p) => p.theme.w};
	}
`;
